import React, { useState } from "react";
import { Badge } from "./ui/badge";
import { Play } from "lucide-react";

const VideoSection = () => {
  const [playing, setPlaying] = useState(false);
  const videoId = "3BK07zkGf7I";
  const thumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;

  return (
    <section id="video" className="py-20 md:py-24 bg-slate-950 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Badge className="bg-green-600 hover:bg-green-600 text-white border-0 mb-4">See Us in Action</Badge>
            <h2 className="text-3xl md:text-5xl font-black tracking-tight leading-tight">
              Inside Hamilton's Smog <span className="text-green-500">— the shop in motion.</span>
            </h2>
            <p className="text-slate-300 mt-4 text-lg leading-relaxed">
              Watch how we handle everything from a 1987 Alfa Romeo on the dyno lane to modern hybrids and heavy-duty diesel trucks. Two bays, two certified technicians, and the fastest turnaround in Marin County.
            </p>
            <ul className="mt-6 space-y-2 text-slate-300">
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-green-500" /> Classic cars welcome — real dyno lane</li>
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-green-500" /> Family-owned since 2021</li>
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-green-500" /> STAR-certified for every California renewal</li>
            </ul>
          </div>

          <div className="relative">
            <div
              className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 aspect-video bg-black cursor-pointer group"
              onClick={() => setPlaying(true)}
            >
              {!playing ? (
                <>
                  <img
                    src={thumbnail}
                    alt="Hamilton's Smog shop video preview"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/40" />
                  <button
                    aria-label="Play video"
                    className="absolute inset-0 flex items-center justify-center"
                  >
                    <span className="relative flex items-center justify-center">
                      <span className="absolute w-24 h-24 rounded-full bg-green-600/40 animate-ping" />
                      <span className="relative w-20 h-20 rounded-full bg-green-600 grid place-items-center shadow-2xl group-hover:bg-green-700 transition-colors">
                        <Play className="w-8 h-8 text-white fill-white ml-1" />
                      </span>
                    </span>
                  </button>
                  <div className="absolute top-4 left-4 right-4 flex items-center justify-between">
                    <span className="text-xs uppercase tracking-wider text-white/90 font-bold bg-black/40 backdrop-blur px-3 py-1.5 rounded-full">Hamilton's Smog on YouTube</span>
                    <span className="text-xs text-white/70 bg-black/40 backdrop-blur px-3 py-1.5 rounded-full">Tap to play</span>
                  </div>
                </>
              ) : (
                <iframe
                  src={embedUrl}
                  title="Hamilton's Smog Video"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              )}
            </div>

            {/* Decorative floating badge */}
            <div className="hidden md:block absolute -bottom-5 -left-5 bg-green-600 text-white rounded-xl px-4 py-3 shadow-xl">
              <div className="text-xs uppercase tracking-widest opacity-80 font-bold">Featured</div>
              <div className="text-base font-black">'87 Alfa Romeo</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
